import { ChangeEvent, useState } from 'react';
import { useDispatch } from 'react-redux';
import { TableBody as Body } from '@mui/material';
import { unwrapResult } from '@reduxjs/toolkit';
import { useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';

import { HeaderProperties } from '../../../../shared/uiComponents/Table/tableProperties';
import { CustomButton, CustomCheckBox } from '../../../../shared/uiComponents';
import { errorNormalizer, formatClientName } from '../../../../shared/Helpers/functions';
import { View } from '../../../../shared/Assets/svgIcons';
import { CustomTableRow, RowTableCell } from '../../../../shared/uiComponents/Table/tableHelpers';

import { DispatchProperties, useSelector } from '../../../../redux/store';
import { PendingApprovalNoteProperties } from '../../../../redux/API/ClientAPIHelpers/soapNoteProperties';
import { setReportIds } from '../../../../redux/State/clientSlice/billingSlice';
import { getSoapNotePDF } from '../../../../redux/State/exportSlice';

export const Headers: HeaderProperties[] = [
	{ id: '0', name: '', width: '40px', isSelectAll: true },
	{ id: '1', name: 'Provider', orderBy: 'userFullName' },
	{ id: '2', name: 'Client', orderBy: 'clientFullName' },
	{ id: '3', name: 'Session Date', orderBy: 'date' },
	{ id: '4', name: 'View' },
];

const CheckboxTableCell = ({ id }: { id: string }) => {
	const dispatch = useDispatch<DispatchProperties>();
	const [params] = useSearchParams();
	const selectAll = params.get('selectAll') === 'true';

	const reportIds = useSelector((state) => state.billing.billingFilters.reportIds);

	const selectNoteHandler = (event: ChangeEvent<HTMLInputElement>) => {
		const { checked } = event.target;

		if (checked) {
			dispatch(setReportIds([...reportIds, id]));

			return;
		}
		dispatch(setReportIds(reportIds.filter((x) => x !== id)));
	};

	return (
		<RowTableCell style={{ width: '40px', textAlign: 'center' }} padding="checkbox">
			<CustomCheckBox
				item={{
					id,
					checked: reportIds.includes(id) || selectAll,
					disabled: selectAll,
				}}
				onChange={selectNoteHandler}
				style={{ marginRight: 0 }}
			/>
		</RowTableCell>
	);
};

const ViewPendingNotePDF = ({ item }: { item: PendingApprovalNoteProperties }) => {
	const dispatch = useDispatch<DispatchProperties>();
	const [loading, setLoading] = useState(false);

	const viewSoapNoteHandler = () => {
		setLoading(true);
		dispatch(
			getSoapNotePDF({
				reportId: item.id,
				includeTrials: true,
			}),
		)
			.then(unwrapResult)
			.then((response) => {
				const objectURL = URL.createObjectURL(response);
				window.open(objectURL);
			})
			.catch(errorNormalizer)
			.finally(() => setLoading(false));
	};

	return (
		<CustomButton
			onClick={viewSoapNoteHandler}
			loading={loading}
			iconOnly={<View />}
			buttonType="secondaryGray"
			style={{ width: '36px', height: '36px' }}
		/>
	);
};

export const TableBody = ({ data }: { data: PendingApprovalNoteProperties[] }) => (
	<Body>
		{data.map((row, index) => (
			<CustomTableRow key={index}>
				<CheckboxTableCell id={row.id} />
				<RowTableCell>{row.userFullName}</RowTableCell>
				<RowTableCell>{formatClientName(row.clientFullName, row.isElc)}</RowTableCell>
				<RowTableCell>{dayjs.utc(row.date).format('MM-DD-YYYY')}</RowTableCell>
				<RowTableCell>
					<ViewPendingNotePDF item={row} />
				</RowTableCell>
			</CustomTableRow>
		))}
	</Body>
);
